var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9134 0.379779C19.7093 -0.108437 19.1259 -0.127965 18.8816 0.33291C17.7513 2.4381 15.7276 3.75042 13.4159 3.75042H10.499C6.63405 3.75042 3.49834 7.10934 3.49834 11.2494C3.49834 11.5228 3.52751 11.7845 3.55303 12.0501C5.87929 10.2652 9.23742 8.74975 13.9993 8.74975C14.3202 8.74975 14.5827 9.03096 14.5827 9.37467C14.5827 9.71837 14.3202 9.99958 13.9993 9.99958C4.83284 9.99958 0.946012 16.0183 0.0855134 18.2797C-0.155134 18.9164 0.129267 19.6428 0.723595 19.9045C1.32157 20.1701 1.99976 19.8615 2.2477 19.2288C2.30239 19.0882 3.00975 17.358 4.8693 15.6902C6.05066 17.4048 8.29671 19.0413 11.2465 18.7054C16.971 18.2602 21 12.7609 21 6.02746C21 4.06678 20.6062 2.03581 19.9134 0.379779Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.a94084e098a4fcd1fd5d18b74f09100d.svg";
export { ForwardRef as ReactComponent };